import Box from '@mui/material/Box';
import loaderImage from '../../../../assets/common/loader.png';

export default function Loader() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        component='img'
        src={loaderImage}
        alt=''
        sx={{
          width: '100%',
          maxWidth: 120,
          animation: 'rotate 6s linear infinite',
          '@keyframes rotate': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' },
          },
        }}
      />
    </Box>
  );
}
